import React, { useState } from 'react';

interface TermsSummaryModalProps {
  open: boolean;
  onAgree: () => void;
  onClose: () => void;
  level: number;
  fee: number;
  fullTerms: string;
}

function formatDateTime(date: Date) {
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
}

const TermsSummaryModal: React.FC<TermsSummaryModalProps> = ({ open, onAgree, onClose, level, fee, fullTerms }) => {
  const [checked, setChecked] = useState(false);
  const now = new Date();
  const effectiveDate = formatDateTime(now);

  // Remove any 'Effective Date:' line from the T&C body
  const cleanedTerms = fullTerms.replace(/Effective Date:.*\n?/i, '');

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-4 relative">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className="text-lg font-bold mb-1 text-gray-900">Terms & Conditions</h2>
        <div className="mb-1 text-xs text-gray-500">
          <strong>Effective Date:</strong> {effectiveDate}
        </div>
        <div className="mb-2 text-xs text-gray-500">
          <strong>Level {level} Fee:</strong> {fee} $
        </div>
        <div className="mb-3 max-h-48 overflow-y-auto border border-gray-200 rounded p-3 bg-gray-50 text-xs text-gray-800 whitespace-pre-wrap">
          {cleanedTerms}
        </div>
        <div className="flex items-center mb-3">
          <input
            id="agree"
            type="checkbox"
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
            className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
          />
          <label htmlFor="agree" className="ml-2 text-xs text-gray-900">
            I agree to the Terms and Conditions
          </label>
        </div>
        <button
          className={`w-full py-2 px-4 rounded bg-indigo-600 text-white font-semibold text-sm ${!checked ? 'opacity-50 cursor-not-allowed' : 'hover:bg-indigo-700'}`}
          disabled={!checked}
          onClick={onAgree}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default TermsSummaryModal; 